import React from 'react';
import classNames from 'classnames';

import css from './VirtualTourCardBadge.module.css';

const BADGE_LABELS = {
  listing: '360° Virtual Tour Available',
  search: '360 Tour',
};

const VirtualTourCardBadge = ({ context = 'search', placement = 'bottom-left', onActivate }) => {
  const label = BADGE_LABELS[context] || BADGE_LABELS.search;
  const isInteractive = typeof onActivate === 'function';
  const BadgeElement = isInteractive ? 'button' : 'span';

  const handleClick = event => {
    event.stopPropagation();
    onActivate();
  };

  return (
    <BadgeElement
      className={classNames(css.root, {
        [css.topLeft]: placement === 'top-left',
        [css.actionable]: isInteractive,
      })}
      aria-label={label}
      {...(isInteractive ? { type: 'button', onClick: handleClick } : {})}
    >
      <svg
        className={css.icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" />
        <polygon
          points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
          fill="none"
          stroke="currentColor"
        />
      </svg>
      <span aria-hidden="true">{label}</span>
    </BadgeElement>
  );
};

export default VirtualTourCardBadge;
